import React from "react";

function PagesTitle() {
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <h1>Coach Registration</h1>
    </div>
  );
}

export { PagesTitle };
